<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>401 Unauthorized</title>
  <style>
    body{
      margin:0;
      padding:0;
      background:#f5f6fa;
      display:flex;
      align-items:center;
      justify-content:center;
      height:100vh;
      color:#333;
    }

    .container{
      text-align:center;
      padding:40px 50px;
      background:#ffffff;
      border:1px solid #e1e4e8;
      border-radius:8px;
      box-shadow:0 4px 12px rgba(0,0,0,0.08);
      max-width:380px;
    }

    h1{
      margin:0 0 10px;
      font-size:42px;
      font-weight:700;
      color:#d9534f;
    }

    p{
      margin:0 0 22px;
      color:#555;
      font-size:15px;
    }

    .btn{
      display:inline-block;
      padding:10px 18px;
      background:#007bff;
      color:#fff;
      text-decoration:none;
      border-radius:4px;
      font-size:14px;
      cursor:pointer;
    }

    .btn:hover{background:#0069d9;}

    .small{
      color:#888;
      font-size:12px;
      margin-top:15px;
    }
  </style>
</head>
<body>

  <div class="container">
    <h1>401</h1>
    <p>You do not have access to view this page.</p>
    <a class="btn" href="/">Go to Home</a>
    <div class="small">If you believe this is an error, contact your administrator.</div>
  </div>

</body>
</html>
